import React from 'react';
import { Star, CheckCircle2, User } from 'lucide-react';
import { motion } from 'framer-motion';
const reviews = [{
  name: 'Sarah M. — Austin, TX',
  date: 'March 2025',
  text: "My 7-year-old had 'the flu' for two months. Plugged this in and it immediately read 25 PPM near his bedroom. The HVAC guy found a cracked heat exchanger the next day. I'm literally shaking writing this. Buy it.",
  avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=80&h=80&fit=crop&crop=face',
  anonymous: false
}, {
  name: 'Tom W. — Chicago, IL',
  date: 'February 2025',
  text: "I'm an HVAC tech with 30 years experience. I test detectors every day. Half of them are dead but still blink green. I put an AirGuard Pro in my own house and tell all my clients to do the same.",
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face',
  anonymous: false
}, {
  name: 'Jennifer K. — Denver, CO',
  date: 'January 2025',
  text: "We almost lost our daughter. The old detector had a green light for 3 years after the sensor died. This one showed 42 PPM the first night. Called the fire department. They found a blocked flue. I can't even talk about it without crying. Just buy it.",
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face',
  anonymous: false
}, {
  name: 'Amanda R. — Seattle, WA',
  date: 'December 2024',
  text: "Took it to an Airbnb in Denver. Plugged it in, saw 000 PPM, and finally slept through the night without anxiety. Best purchase I've made for my family's safety.",
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop&crop=face',
  anonymous: false
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-primary py-5 md:py-8 px-4 sm:px-6 lg:px-8" data-id="element-367">
      <div className="max-w-5xl mx-auto" data-id="element-368">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6" data-id="element-369">
          <span className="text-accent-orange font-medium text-[12px] tracking-wide uppercase mb-2 block" data-id="element-370">
            REAL STORIES FROM REAL FAMILIES
          </span>
          <h2 className="text-[28px] font-bold text-text-primary mb-2" data-id="element-371">
            The Device That Finally Gave Them Answers.
          </h2>
          <div className="flex items-center justify-center gap-2 text-[16px] text-text-primary font-medium" data-id="element-372">
            <div className="flex items-center text-star-gold" data-id="element-373">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-374" />)}
            </div>
            <span data-id="element-375">4.9/5 — Based on 4,800+ verified reviews</span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-376">
          {reviews.map((review, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.1
        }} className="bg-bg-card rounded-xl p-4 border border-border-subtle shadow-card" data-id="element-377">
              <div className="flex items-center gap-3 mb-3" data-id="element-378">
                {review.anonymous ? <div className="w-11 h-11 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0 border-2 border-border-subtle" data-id="element-379">
                    <User className="w-5 h-5 text-gray-400" data-id="element-380" />
                  </div> : <img src={review.avatar!} alt={review.name} className="w-11 h-11 rounded-full object-cover border-2 border-border-subtle" data-id="element-381" />}
                <div className="flex-1" data-id="element-382">
                  <div className="font-bold text-text-primary text-[15px]" data-id="element-383">
                    {review.anonymous ? 'Anonymous' : review.name}
                  </div>
                  <div className="text-text-secondary text-[12px]" data-id="element-384">
                    {review.date}
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between mb-2.5" data-id="element-385">
                <div className="flex items-center text-star-gold" data-id="element-386">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-387" />)}
                </div>
                <div className="flex items-center text-accent-green text-[11px] font-bold bg-green-50 px-2 py-0.5 rounded-full" data-id="element-388">
                  <CheckCircle2 className="w-3 h-3 mr-1" data-id="element-389" />
                  Verified Buyer
                </div>
              </div>
              <p className="text-text-secondary text-[14px] leading-[1.5]" data-id="element-390">
                &ldquo;{review.text}&rdquo;
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}